// src/googleAuth.js
// Lógica de login/cadastro com Google — compartilhada entre Login.jsx e
// PublicOnboarding.jsx. Mantida em um único lugar pra evitar que os dois
// arquivos fiquem dessincronizados se o fluxo do Google mudar no futuro.
import { supabase } from "./supabaseClient";
import { Capacitor } from "@capacitor/core";

// Retorna { error: string|null }. Quem chama decide como mostrar loading/erro.
// supabase.auth.signInWithIdToken (nativo) e signInWithOAuth (web) já cobrem
// cadastro E login no mesmo fluxo: se o usuário não existir, é criado agora.
export async function signInWithGoogle() {
  try {
    if (Capacitor.isNativePlatform()) {
      const { GoogleAuth } = await import("@codetrix-studio/capacitor-google-auth");
      await GoogleAuth.initialize({
        clientId: "567922633159-3pmqjql8aise8ka5r5qjn7tfgcl2d0sa.apps.googleusercontent.com",
        scopes: ["profile", "email"],
        grantOfflineAccess: true,
      });
      const googleUser = await GoogleAuth.signIn();
      const idToken = googleUser?.authentication?.idToken;
      if (!idToken) return { error: "Não foi possível obter o token do Google." };
      const { error: authError } = await supabase.auth.signInWithIdToken({
        provider: "google",
        token: idToken,
      });
      if (authError) return { error: "Erro ao entrar com Google: " + authError.message };
      return { error: null };
    } else {
      // Web: fluxo OAuth normal via redirect
      const { error: authError } = await supabase.auth.signInWithOAuth({
        provider: "google",
        options: {
          redirectTo: `${window.location.origin}/auth/callback`,
          queryParams: { access_type: "offline", prompt: "consent" },
        },
      });
      if (authError) return { error: "Erro ao entrar com Google: " + authError.message };
      return { error: null };
    }
  } catch (err) {
    return { error: "Erro ao entrar com Google. Tente novamente." };
  }
}
